<mat-toolbar color="accent">Waive Deposit</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <p class="!m-0 text-sm opacity-75">
      Waiving clears the deposit requirement for this appointment. The patient
      won't be asked to pay, and the appointment can be confirmed without one.
    </p>

    <p class="!m-0 text-sm opacity-75">
      The reason is saved against the appointment so the rest of the team can
      see why the deposit was waived.
    </p>

    <form [formGroup]="form">
      <mat-form-field class="w-full">
        <mat-label>Waiver Reason</mat-label>
        <textarea
          matInput
          cdkFocusInitial
          rows="4"
          formControlName="waiverReason"
          placeholder="e.g. Deposit collected in person"
        ></textarea>
        @if (hasRequiredError) {
          <mat-error>Reason is required</mat-error>
        }
        @if (hasMinLengthError) {
          <mat-error>Reason must be at least 3 characters</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!form.valid"
      (click)="onConfirm()"
    >
      Waive Deposit
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
